import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { api } from './api';
import { useLoad } from './hooks';
import { IdentityContext, type Identity } from './context';
import { Layout } from './Layout';
import { Loading, ErrorPanel } from './components/Common';
import { DashboardPage } from './pages/Dashboard';
import { DevicesPage } from './pages/Devices';
import { DeviceDetailPage } from './pages/DeviceDetail';
import { ActivationCodesPage } from './pages/ActivationCodes';
import { UsagePage } from './pages/Usage';
import { AuditPage } from './pages/Audit';
import { AdministratorsPage } from './pages/Administrators';
import { SettingsPage } from './pages/Settings';
import './styles.css';

function App() {
  const identity = useLoad(() => api<Identity>('/me'), []);
  if (identity.loading) return <div className="center-screen"><Loading text="正在验证管理员身份…" /></div>;
  if (identity.error || !identity.data) return <LoginPanel message={identity.error || '无法读取管理员身份'} onLogin={identity.reload} />;
  return <IdentityContext.Provider value={identity.data}>
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<DashboardPage />} />
          <Route path="devices" element={<DevicesPage />} />
          <Route path="devices/:deviceId" element={<DeviceDetailPage />} />
          <Route path="activation-codes" element={<ActivationCodesPage />} />
          <Route path="usage" element={<UsagePage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="administrators" element={<AdministratorsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="*" element={<div className="panel">页面不存在</div>} />
        </Route>
      </Routes>
    </BrowserRouter>
  </IdentityContext.Provider>;
}

function LoginPanel({ message, onLogin }: { message: string; onLogin: () => Promise<void> }) {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(message);
  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await api('/login', { method: 'POST', body: JSON.stringify({ password }) });
      await onLogin();
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : String(reason));
    } finally {
      setBusy(false);
    }
  }
  return <div className="center-screen">
    <form className="panel login-panel" onSubmit={submit}>
      <h1>Dola 授权管理后台</h1>
      <p>输入管理员密码继续。</p>
      {error && <div className="notice error">{error}</div>}
      <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoFocus placeholder="管理员密码" />
      <button disabled={busy || !password}>{busy ? '登录中…' : '登录'}</button>
    </form>
  </div>;
}

ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);
